/* tslint:disable */
/* eslint-disable */
/**
 * Melco APIService APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    SharedserviceMelcoModelsPreview,
    SharedserviceMelcoModelsPreviewFromJSON,
    SharedserviceMelcoModelsPreviewFromJSONTyped,
    SharedserviceMelcoModelsPreviewToJSON,
} from './';

/**
 * 
 * @export
 * @interface SharedserviceMelcoModelsDesignCollectionDefaultDesign
 */
export interface SharedserviceMelcoModelsDesignCollectionDefaultDesign {
    /**
     * 
     * @type {string}
     * @memberof SharedserviceMelcoModelsDesignCollectionDefaultDesign
     */
    id?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SharedserviceMelcoModelsDesignCollectionDefaultDesign
     */
    name?: string | null;
    /**
     * 
     * @type {Array<SharedserviceMelcoModelsPreview>}
     * @memberof SharedserviceMelcoModelsDesignCollectionDefaultDesign
     */
    previews?: Array<SharedserviceMelcoModelsPreview> | null;
}

export function SharedserviceMelcoModelsDesignCollectionDefaultDesignFromJSON(json: any): SharedserviceMelcoModelsDesignCollectionDefaultDesign {
    return SharedserviceMelcoModelsDesignCollectionDefaultDesignFromJSONTyped(json, false);
}

export function SharedserviceMelcoModelsDesignCollectionDefaultDesignFromJSONTyped(json: any, ignoreDiscriminator: boolean): SharedserviceMelcoModelsDesignCollectionDefaultDesign {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'name': !exists(json, 'name') ? undefined : json['name'],
        'previews': !exists(json, 'previews') ? undefined : (json['previews'] === null ? null : (json['previews'] as Array<any>).map(SharedserviceMelcoModelsPreviewFromJSON)),
    };
}

export function SharedserviceMelcoModelsDesignCollectionDefaultDesignToJSON(value?: SharedserviceMelcoModelsDesignCollectionDefaultDesign | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'name': value.name,
        'previews': value.previews === undefined ? undefined : (value.previews === null ? null : (value.previews as Array<any>).map(SharedserviceMelcoModelsPreviewToJSON)),
    };
}


